import { Injectable } from '@angular/core';

import { ErrorCode } from '@ap/interface-apic-authenticatie-fido';

import { ValidationResult, ValidationResultType } from './validation.model';

@Injectable({
    providedIn: 'root'
})
export class ApValidationResultService {
    private readonly recoverableReasons = [
        ErrorCode.INVALID_CREDENTIALS,
        ErrorCode.TOKEN_BLOCKED,
        ErrorCode.TOKEN_BLOCKED_PERMANENTLY_AT_NEXT_FAILED_SIGNING,
        ErrorCode.TOKEN_BLOCKED_PERMANENTLY,
        ErrorCode.TOKEN_BLOCKED_AT_NEXT_FAILED_SIGNING,
        ErrorCode.TOKEN_NOT_ACTIVE,
        ErrorCode.MUST_CHANGE_CREDENTIALS,
        ErrorCode.MUST_CHANGE_PASSWORD
    ];
    private readonly processRetryReasons = [ErrorCode.TASK_EXPIRED];

    public getValidationResult(reason: string, anonymous: boolean): ValidationResult {
        if (this.isUpdatePassword(reason) && anonymous) {
            return { reason, resultType: ValidationResultType.UPDATE_PASSWORD };
        }
        if (this.isUpdateUsernamePassword(reason) && anonymous) {
            return { reason, resultType: ValidationResultType.UPDATE_USERNAME_PASSWORD };
        }
        if (this.isRetryable(reason)) {
            return { reason, resultType: ValidationResultType.PROCESS_RETRY };
        }
        if (this.isRecoverable(reason)) {
            return { reason, resultType: ValidationResultType.COMPONENT_RETRY };
        }

        return { resultType: ValidationResultType.DONE };
    }

    public isRecoverable(reason: string): boolean {
        return this.recoverableReasons.map((recoverableReason) => recoverableReason.toString()).indexOf(reason) >= 0;
    }

    private isRetryable(reason: string): boolean {
        return this.processRetryReasons.map((recoverableReason) => recoverableReason.toString()).indexOf(reason) >= 0;
    }

    private isUpdatePassword(reason: string): boolean {
        return ErrorCode.MUST_CHANGE_PASSWORD.toString() === reason;
    }

    private isUpdateUsernamePassword(reason: string): boolean {
        return ErrorCode.MUST_CHANGE_CREDENTIALS.toString() === reason;
    }
}
